export default function translate(i18n, propriete) {
  if (propriete === 'datePlanification') {
    return i18n.t('editionIntervention.error.date');
  }
  if (propriete === 'actionLogistique') {
    return i18n.t('editionIntervention.error.sujet');
  }
  if (propriete === 'demandeurId') {
    return i18n.t('editionIntervention.error.demandeur');
  }
  if (propriete === 'demandePereId') {
    return i18n.t('editionIntervention.error.demandePereId');
  }
  if (propriete === 'agenceId') {
    return i18n.t('editionIntervention.error.agence');
  }
  if (propriete === 'typeOtId') {
    return i18n.t('demandeLogistique.creationOrUpdate.typeOt');
  }
  return propriete;
}
